import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';

/**
 * Libelle court affiche au-dessus de l'axe d'un champ.
 * `incSpd` : chaque axe affiche le libelle de son champ (`inc`, `spd`).
 */
export const WORKOUT_MODE_LABELS: Readonly<Record<WorkoutMode, string>> = {
    ftp: 'FTP',
    watts: 'WATTS',
    res: 'RES',
    slope: 'SLOPE',
    inc: 'INC',
    spd: 'SPD',
    incSpd: 'INCSPD',
};
